module.exports = __webpack_public_path__ + "img/KSC09560.b77ca596.webp";